<template>
  <div :class="$style.container">
    <TabList
      :activeTab="activeTabIndex"
      :class="$style.tabList"
      :customActiveTabStyle="$style.activeTab"
      :customNavStyle="$style.tabNav"
      :customTabStyle="$style.tabLink"
      :tabs="tabs"
      @active-tab-change="handleActiveTabChange"
    />
  </div>
</template>

<script>
import {
  FilterComponentConsts,
  ItemTypeConsts,
  ItemTypeRoutes,
} from 'client/util/Constants';
import BrowserPatchManagementMainPanel from 'client/BrowserManagement/BrowserPatchManagementMainPanel';
import MainPanelMixin from 'client/components/MainPanel/mixins/MainPanelMixin';
import OsPatchManagementMainPanel from 'client/OsManagement/OsPatchManagementMainPanel';
import PoliciesMixin from 'client/OsManagement/mixins/PoliciesMixin';
import RouterService from 'client/util/RouterService';
import TabList from 'client/components/TabList/TabList';

export default {
  name: 'PatchManagementPolicies',

  components: {
    TabList,
  },

  mixins: [MainPanelMixin, PoliciesMixin],

  props: {
    initialTabIndex: {
      type: Number,
      default: 0,
    },
  },

  data: () => ({
    activeTabIndex: 0,
  }),

  computed: {
    tabs() {
      return [
        {
          title: 'OS',
          component: OsPatchManagementMainPanel,
          componentProps: {
            isAsideOpen: false,
            itemType: ItemTypeConsts.osPatchManagement,
            selectedModelId: '',
            setSelectedModelId: this.setSelectedModelId,
            useDropDownFilterComponent:
              FilterComponentConsts.OsPolicyDropDownFilter,
          },
        },
        {
          title: 'Browser',
          component: BrowserPatchManagementMainPanel,
          componentProps: {
            isAsideOpen: false,
            itemType: ItemTypeConsts.browserPatchManagement,
            selectedModelId: '',
            setSelectedModelId: this.setSelectedModelId,
            useDropDownFilterComponent:
              FilterComponentConsts.BrowserPolicyDropDownFilter,
          },
        },
      ];
    },
  },

  beforeMount() {
    this.activeTabIndex = this.initialTabIndex ? this.initialTabIndex : 0;
  },

  methods: {
    handleActiveTabChange(tabIndex) {
      let path = ItemTypeRoutes[ItemTypeConsts.osPatchManagement];
      if (tabIndex === 1) {
        path = ItemTypeRoutes[ItemTypeConsts.browserPatchManagement];
      }
      this.activeTabIndex = tabIndex;
      RouterService.redirect({
        path,
        viewport: this.viewport,
        vueRouter: this.$router,
      });
    },
  },
};
</script>

<style module>
.container,
.tabList {
  background: var(--jcWhite300);
  height: 100%;
}

.tabLink {
  border-radius: 16px;
  color: var(--jcGrey);
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0 1rem 0 0;
  padding: 0.5rem 0.75rem;
}

.activeTab a {
  background: var(--jcWhite50);
  border: 2px solid var(--jcPrimary);
  color: var(--jcGrey600);
}

.tabNav {
  margin: 0 0 0.25rem 0.85rem;
  padding: 1rem 0;
}
</style>
